export const PREVIEW_UNKNOWN = 0;
export const PREVIEW_ORIGINAL_MISSING = 1;
export const PREVIEW_FAILED = 2;
export const PREVIEW_NOT_AVAILABLE = 3;
export const PREVIEW_IN_PROGRESS = 4;
export const PREVIEW_READY = 5;
export const PREVIEW_LOCKED = -1;
